import NeevayNetwork from "./NeevayNetwork";

export default NeevayNetwork;
